import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AppProviders";
import { api } from "@/lib/api";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminAdmins from "@/pages/admin/AdminAdmins";
import AdminVideoStats from "@/pages/admin/AdminVideoStats";

const TABS = [
  ["dashboard", "Dashboard"],
  ["formations", "Formations"],
  ["users", "Utilisateurs"],
  ["payments", "Paiements"],
  ["testimonials", "Témoignages"],
  ["admins", "Admins"],
  ["stats", "Suivi vidéos"],
];

export default function Admin() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("dashboard");
  const [stats, setStats] = useState(null);

  const isAdmin = user && user.role === "admin";

  const loadStats = () => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  };

  useEffect(() => {
    if (user === false) { navigate("/auth?next=/admin", { replace: true }); return; }
    if (user && user.role !== "admin") { navigate("/", { replace: true }); return; }
    if (isAdmin) loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!isAdmin) return <div className="pt-40 pb-40 px-10 text-ink/40">Chargement…</div>;

  return (
    <div className="pt-24 md:pt-28 pb-28 min-h-screen" data-testid="admin-page">
      <div className="max-w-[1500px] mx-auto px-4 md:px-10">
        <div className="flex flex-wrap items-center justify-between gap-6">
          <h1 className="font-display font-semibold tracking-tighter text-3xl md:text-5xl text-ink">Back-office</h1>
        </div>
        <div className="mt-5 -mx-4 px-4 md:mx-0 md:px-0 overflow-x-auto" data-testid="admin-tabs-bar">
          <div className="flex gap-2 w-max md:w-auto md:flex-wrap pb-1">
            {TABS.map(([key, label]) => (
              <button
                key={key}
                data-testid={`admin-tab-${key}`}
                onClick={() => setTab(key)}
                className={`text-xs uppercase tracking-[0.2em] px-4 py-2.5 border transition-colors whitespace-nowrap ${tab === key ? "border-ember text-ember bg-ember/5" : "border-ink/15 text-ink/50 hover:text-ink"}`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {tab === "dashboard" && <AdminDashboard stats={stats} onNavigate={setTab} />}
        {tab === "formations" && <AdminCourses onChanged={loadStats} />}
        {tab === "users" && <AdminUsers onChanged={loadStats} />}
        {tab === "payments" && <AdminPayments onChanged={loadStats} />}
        {tab === "testimonials" && <AdminTestimonials />}
        {tab === "admins" && <AdminAdmins />}
        {tab === "stats" && <AdminVideoStats />}
      </div>
    </div>
  );
}
